module.exports = __webpack_public_path__ + "static/media/background.898d65d0.jpg";